import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { SessionProvider } from "./session.js";
import { applySettings } from "./lib/settings.js";
import { warmUpVoices } from "./lib/text.js";
// Bundled, not from a font CDN: no third-party request, and it works offline.
// The browser only downloads it once the readable-font setting uses it.
import "@fontsource/atkinson-hyperlegible/400.css";
import "@fontsource/atkinson-hyperlegible/700.css";
import "./styles/app.css";

applySettings();
warmUpVoices();

// Opens the app without a connection (issue #118). Only in a build: in `vite
// dev` it would serve yesterday's modules.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
}

const root = document.getElementById("root");
if (!root) throw new Error("root missing");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
